import { PageLayout } from "@/shared/components";

import { Triggers } from "./components";

/** The Triggers section's landing page: chrome around the one triggers list. */
export function TriggersPage() {
  return (
    <PageLayout title="Roboto - Triggers" headerContentLeft="Triggers">
      <Triggers />
    </PageLayout>
  );
}
